// Plusieurs types de jeux rapportent le même nombre de points (ex: PAT, Simple et ExtraPt valent tous 1 point) : c'est voulu.
/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
export enum ScoringPlay {
  TD = 6,
  Safety = 2,
  FG = 3,
  PAT = 1,
  Simple = 1,
  Conversion2Pt = 2,
  ExtraPt = 1,
}
/* eslint-enable @typescript-eslint/no-duplicate-enum-values */
